<template>
  <FormContainer>
    <template #title>Formation</template>
    <template #content>
      <div class="form__bloc">
        <WrapperDropdown
          id="field_30 field_70"
          v-model="typeQualificationModel"
          label="Sanction"
          class="col-18 col-sm-36"
          :items="lov.TypeSanction"
          :required="metaModuleEnCours?.typeQualification?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.typeQualification?.$messageErreurDirty!!"
          key-id="code"
          key-label="intitule"
          :readonly
          :disabled="model?.sousDispositif === 'CleaSocleCompetence'"
          help="Type de qualification visée"
        />
        <WrapperToggleSwitch
          v-if="moduleEnCours?.typeQualification === 'Cqp'"
          id="field_31 field_71"
          :model-value="moduleEnCours?.typeReferentielFormation"
          @update:model-value="(value: any) => updateModule('typeReferentielFormation', activeModuleIndex!, value)"
          label="Souhaitez-vous rechercher votre formation par ? "
          :items="typeReferentielFormationItems"
          :required="metaModuleEnCours?.typeReferentielFormation?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.typeReferentielFormation?.$messageErreurDirty!!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
        <WrapperToggleSwitch
          v-else
          id="field_31 field_71"
          label="Souhaitez-vous rechercher votre formation par ? "
          :items="typeReferentielFormationItems"
          disabled
          class="col-10 col-md-14 col-sm-36"
        />
        <BasicText
          v-if="metaModuleEnCours?.formacode?.$status === PropertyStatus.Required"
          class="col-36"
          size="body-m"
          font-style="italic"
        >
          Si vous ne connaissez pas votre Domaine de formation / Formacode, merci de vous référer au
          <BasicLink
            label="Site Centre Inffo"
            @link-click="redirectExterne('https://formacode.centre-inffo.fr/spip.php?page=thesaurus')"
          />
        </BasicText>
        <BasicText
          v-if="
            metaModuleEnCours?.rncp?.$status === PropertyStatus.Required ||
            metaModuleEnCours?.repertoireSpecifique?.$status === PropertyStatus.Required
          "
          class="col-36"
          size="body-m"
          font-style="italic"
        >
          Si vous ne connaissez pas votre code "RNCP" ou votre code "Répertoire Spécifique", merci de vous référer au
          Site
          <BasicLink
            label="France compétences."
            @link-click="redirectExterne('https://www.francecompetences.fr/recherche-resultats')"
          />
        </BasicText>
      </div>
      <div class="form__bloc">
        <WrapperAutocomplete
          v-if="metaModuleEnCours?.formacode?.$status !== PropertyStatus.NotPresent"
          id="field_32 field_72"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          :model-value="moduleEnCours?.formacode"
          @update:model-value="(value: any) => updateModule('formacode', activeModuleIndex!, value)"
          :search="searchFormacode"
          label="Domaine de formation / Formacode"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="EX : boulangerie ou 45022108"
          :readonly
          strict
          :required="metaModuleEnCours?.formacode?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.formacode?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_32 field_72"
          :search="searchFormacode"
          label="Formacode"
          class="col-18 col-sm-36"
          placeholder="EX : boulangerie ou 45022108"
          disabled
        />
        <WrapperAutocomplete
          v-if="metaModuleEnCours?.rncp?.$status !== PropertyStatus.NotPresent"
          id="field_33 field_73"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          :model-value="moduleEnCours?.rncp"
          @update:model-value="(value: any) => updateModule('rncp', activeModuleIndex!, value)"
          :search="searchRNCP"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="3"
          placeholder="Ex: boulangerie ou 39257"
          :readonly
          strict
          :required="metaModuleEnCours?.rncp?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.rncp?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_33 field_73"
          :search="searchRNCP"
          label="Code RNCP"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: boulangerie ou 39257"
          disabled
        />
        <WarningRncp
          v-if="metaModuleEnCours?.rncp?.$status !== PropertyStatus.NotPresent"
          class="col-36"
          :rncp="moduleEnCours?.rncp"
          :date-conclusion="moduleEnCours?.dateDebut"
          :get-rncp
          :readonly
        />
        <WrapperAutocomplete
          v-if="metaModuleEnCours?.repertoireSpecifique?.$status !== PropertyStatus.NotPresent"
          id="field_33 field_73"
          key-id="code"
          key-label="intitule"
          :get-item-label="getLabel"
          :get-input-text="getLabel"
          :model-value="moduleEnCours?.repertoireSpecifique"
          @update:model-value="(value: any) => updateModule('repertoireSpecifique', activeModuleIndex!, value)"
          :search="searchRepertoireSpeficiqueClea"
          label="Répertoire spécifique (RS)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          :search-min-length="estClea ? 0 : 3"
          placeholder="Ex: Socle de connaiss... ou 6269"
          :readonly
          strict
          :required="metaModuleEnCours?.repertoireSpecifique?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.repertoireSpecifique?.$messageErreurDirty!"
        />
        <WrapperAutocomplete
          v-else
          id="field_33 field_73"
          :search="searchRepertoireSpeficiqueClea"
          label="Répertoire spécifique (RS)"
          hint="Code ou intitulé"
          class="col-18 col-sm-36"
          placeholder="Ex: Socle de connaiss... ou 6269"
          disabled
        />
        <WrapperDropdown
          id="field_46 field_86"
          :model-value="moduleEnCours?.niveauCertificationVisee"
          @update:model-value="(value: any) => updateModule('niveauCertificationVisee', activeModuleIndex!, value)"
          label="Niveau de la certification visée par la formation"
          key-id="code"
          key-label="intitule"
          :required="metaModuleEnCours?.niveauCertificationVisee?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.niveauCertificationVisee?.$messageErreurDirty!"
          class="col-18 col-sm-36"
          :items="lov.NiveauDiplome"
          :readonly
        />
        <WrapperInput
          id="field_unknown"
          v-model="intituleModel"
          label="Intitulé de formation"
          :required="metaModuleEnCours?.intitule?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.intitule?.$messageErreurDirty!"
          class="col-36"
          :readonly
          :disabled="metaModuleEnCours?.formacode?.$status !== PropertyStatus.Required"
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_47 field_87"
          :model-value="moduleEnCours?.dateDebut"
          @update:model-value="(value: any) => updateModule('dateDebut', activeModuleIndex!, value)"
          label="Début de formation"
          :required="metaModuleEnCours?.dateDebut?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dateDebut?.$messageErreurDirty!!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :readonly
        />
        <WrapperInputDate
          id="field_48 field_88"
          :model-value="moduleEnCours?.dateFin"
          @update:model-value="(value: any) => updateModule('dateFin', activeModuleIndex!, value)"
          label="Fin de formation"
          :required="metaModuleEnCours?.dateFin?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dateFin?.$messageErreurDirty!!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :readonly
        />
        <WrapperInputNumber
          id="field_49 field_89"
          :model-value="moduleEnCours?.duree"
          @update:model-value="(value: any) => updateModule('duree', activeModuleIndex!, value)"
          label="Durée de formation en heures"
          :required="metaModuleEnCours?.duree?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.duree?.$messageErreurDirty!"
          class="col-9 col-md-18 col-sm-36"
          placeholder="Heures"
          :decimal="2"
          :readonly
        />
        <WrapperInputNumber
          id="field_50 field_90"
          :model-value="moduleEnCours?.dureeJours"
          @update:model-value="(value: any) => updateModule('dureeJours', activeModuleIndex!, value)"
          label="Durée de formation en jours"
          :required="metaModuleEnCours?.dureeJours?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.dureeJours?.$messageErreurDirty!"
          class="col-9 col-md-18 col-sm-36"
          placeholder="Jours"
          :decimal="1"
          :readonly
        />
        <BasicAlert
          v-if="alertDateModule"
          class="col-18 col-md-36 col-sm-36"
          alertType="warning"
          alertLabel="Il existe d’autres formations sur la même période. Verifiez bien les dates des différents modules avant de valider."
        />
        <BasicAlert
          v-if="alertDureeModule"
          class="col-18 col-md-36 col-sm-36"
          alertType="warning"
          alertLabel="La durée en heures semble dépasser l'équivalent en jours de la période de formation (à raison de 7 heures par jour)."
        />
        <BasicAlert
          v-if="alertDureeModuleVAE"
          class="col-18 col-md-36 col-sm-36"
          alertType="danger"
          alertLabel="Pour la VAE, la durée ne doit pas dépasser 48 heures, sauf si une convention ou un accord collectif prévoit autrement."
        />
      </div>
      <div
        class="form__bloc"
        v-if="moduleEnCours?.typeModule === 'Externe'"
      >
        <WrapperDropdown
          id="field_51"
          :model-value="moduleEnCours?.typeFormation"
          @update:model-value="(value: any) => updateModule('typeFormation', activeModuleIndex!, value)"
          label="Type de formation"
          key-id="code"
          key-label="intitule"
          :required="metaModuleEnCours?.typeFormation?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.typeFormation?.$messageErreurDirty!"
          class="col-18 col-sm-36"
          :items="lov.TypeFormation"
          :readonly
        />
        <WrapperDropdown
          id="field_52"
          :model-value="moduleEnCours?.objectifPrestataire"
          @update:model-value="(value: any) => updateModule('objectifPrestataire', activeModuleIndex!, value)"
          label="Objectif général de l'organisme de formation"
          key-id="code"
          key-label="intitule"
          :required="metaModuleEnCours?.objectifPrestataire?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.objectifPrestataire?.$messageErreurDirty!"
          class="col-18 col-sm-36"
          :items="lov.ObjectifPrestataire"
          :readonly
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { computed, inject, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDemandeAFStore } from '@/features/interface/demande/af/useDemandeAFStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/AF'
  import { ModuleActionKey, type ModuleAction } from '../../useModuleActions'
  import { typeReferentielFormationItems } from '@/features/interface/demande/af/dropdown-items'
  import type { LovItemDTO } from '@/features/api/extranet/dto/Lov'
  import { AF_INJECT, type DemandeAFActions } from '../../../../DemandeAF.type'
  import { HINT_DATE, PLACEHOLDER_DATE, FormContainer, WarningRncp } from '@/features/interface/demande/shared'
  import type { SearchRs } from '@/features/services/demande/DemandeAllService.types'
  import type { TypeQualification } from '@/features/domaine/types/opco/Demande/AF'
  import {
    checkDateInRange,
    deepEqual,
    getNbJour,
    isDate,
    isNullUndefinedOrEmptyString,
    isNumber,
  } from '@/features/shared/tools'
  import { getRangeDate } from '@/features/domaine/regles-akto/shared'
  import { redirectExterne } from '@/features/shared/tools/url'

  const { searchRNCP, searchFormacode, searchRs, getRncp } = inject<DemandeAFActions>(AF_INJECT)!

  const store = useDemandeAFStore()
  const { setupArrayUpdaterWithKey, setupFieldWithOptions } = store
  const { moduleEnCours, activeModuleIndex, metaModuleEnCours } = inject<ModuleAction>(ModuleActionKey)!

  const { model, readonly, lov } = storeToRefs(store)

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

  const estClea = computed<boolean>(() => model.value?.sousDispositif === 'CleaSocleCompetence')

  const typeQualificationModel = setupFieldWithOptions<TypeQualification | null>({
    getValue: () => moduleEnCours.value?.typeQualification ?? null,
    setPatch(patch, value) {
      const modelePatch = patch.formation!.modules!.at(activeModuleIndex.value!)
      modelePatch!.typeQualification = value
      if (
        value === 'AttestationStage' &&
        isNullUndefinedOrEmptyString(modelePatch!.niveauCertificationVisee) &&
        model.value?.sousDispositif !== 'CleaSocleCompetence'
      )
        modelePatch!.niveauCertificationVisee = 'SansNiveauSpecifique'
      else modelePatch!.niveauCertificationVisee = null
    },
  })

  const intituleModel = setupFieldWithOptions<string | null>({
    getValue: () => moduleEnCours.value?.intitule ?? null,
    setPatch(patch, value) {
      const modelePatch = patch.formation!.modules!.at(activeModuleIndex.value!)
      modelePatch!.intitule = value
    },
  })

  watch(
    () => {
      return {
        statusRncp: metaModuleEnCours.value?.rncp?.$status,
        statusFormacode: metaModuleEnCours.value?.formacode?.$status,
        statusRs: metaModuleEnCours.value?.repertoireSpecifique?.$status,
        rncp: moduleEnCours.value?.rncp,
        formacode: moduleEnCours.value?.formacode,
        rs: moduleEnCours.value?.repertoireSpecifique,
        index: activeModuleIndex.value,
      }
    },
    (newValues, oldValues) => {
      if (deepEqual(newValues, oldValues)) return
      const { statusRncp, statusFormacode, statusRs, rncp, rs } = newValues

      let newIntitule: string | null = null

      // Cas si on change de modules
      if (newValues.index !== oldValues.index) return

      if (statusFormacode === PropertyStatus.Required) {
        if (oldValues.statusFormacode === statusFormacode) {
          return
        }
      } else if (statusRncp === PropertyStatus.Required) {
        if (rncp?.code) {
          newIntitule = rncp.intitule
        }
      } else if (statusRs === PropertyStatus.Required) {
        if (rs?.code) {
          newIntitule = rs.intitule
        }
      }

      if (newIntitule != null) {
        intituleModel.value = newIntitule
      }
    },
  )

  const searchRepertoireSpeficiqueClea = (search: string) => {
    const query: SearchRs = { search, estClea: estClea.value }
    return searchRs(query)
  }

  /* Autocomplete */
  const getLabel = function (value: LovItemDTO<string>) {
    return `${value.code} - ${value.intitule}`
  }

  const alertDateModule = computed<boolean>(() => {
    // on contrôle la date de début
    if (isDate(moduleEnCours.value?.dateDebut)) {
      const dateDebut = new Date(moduleEnCours.value?.dateDebut)
      if (
        // si la date de début est dans la période d'un autre module on affiche le message
        model.value?.formation?.modules?.filter(
          (x) =>
            x !== moduleEnCours.value &&
            checkDateInRange(dateDebut, getRangeDate(new Date(x.dateDebut!), new Date(x.dateFin!))),
        ).length
      )
        return true
    }
    // on contrôle la date de fin
    if (isDate(moduleEnCours.value?.dateFin)) {
      const dateFin = new Date(moduleEnCours.value?.dateFin)
      if (
        // si la date de fin est dans la période d'un autre module on affiche le message
        model.value?.formation?.modules?.filter(
          (x) =>
            x !== moduleEnCours.value &&
            checkDateInRange(dateFin, getRangeDate(new Date(x.dateDebut!), new Date(x.dateFin!))),
        ).length
      )
        return true
    }

    return false
  })

  const alertDureeModule = computed<boolean>(() => {
    // si pas de date, on ne contrôle pas
    if (isDate(moduleEnCours.value?.dateDebut) && isDate(moduleEnCours.value?.dateFin)) {
      const dateDebut = new Date(moduleEnCours.value?.dateDebut)
      const dateFin = new Date(moduleEnCours.value?.dateFin)

      // nb jour + 1
      const nbJour = getNbJour(dateDebut, dateFin) + 1
      // on contrôle la date de durée si elle est renseignée
      if (isNumber(moduleEnCours.value.duree)) {
        const duree = Number(moduleEnCours.value.duree)
        if (duree / 7 > nbJour) return true
      }
    }

    return false
  })

  const alertDureeModuleVAE = computed<boolean>(() => {
    if (
      model.value?.sousDispositif === 'ValidationAcquisExperiences' &&
      moduleEnCours.value?.duree &&
      moduleEnCours.value?.duree > 48
    )
      return true
    return false
  })
</script>

<style scoped lang="less">
  .messageInformation {
    font-style: italic;
  }
</style>
